import React from "react";
import { motion } from "framer-motion";
import { ASSETS } from "@/lib/data";

// Reveals its children as if emerging from a puff of smoke.
export const SmokeReveal = ({ children, className = "", tint = "cyan", y = 40, delay = 0, ...rest }) => {
  const smoke = tint === "pink" ? ASSETS.smokePink : ASSETS.smokeCyan;
  return (
    <div className={`relative ${className}`} {...rest}>
      {/* Smoke burst behind content */}
      <motion.img
        src={smoke}
        alt=""
        aria-hidden
        initial={{ opacity: 0, scale: 0.7, filter: "blur(16px)" }}
        whileInView={{
          opacity: [0, 0.28, 0.1],
          scale: [0.7, 1.2, 1.35],
          filter: ["blur(16px)", "blur(6px)", "blur(12px)"],
        }}
        viewport={{ once: true, margin: "-120px" }}
        transition={{ duration: 1.6, delay, ease: "easeOut" }}
        className="pointer-events-none absolute left-1/2 top-1/2 -z-10 w-[120%] max-w-none -translate-x-1/2 -translate-y-1/2 select-none"
        style={{ mixBlendMode: "screen" }}
      />
      {/* Content */}
      <motion.div
        initial={{ opacity: 0, y, filter: "blur(8px)" }}
        whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.9, delay: delay + 0.15, ease: [0.16, 1, 0.3, 1] }}
      >
        {children}
      </motion.div>
    </div>
  );
};
